<script setup lang="ts">
import { useFirebaseAuth } from '~/composables/useFirebaseAuth';
import LButton from '~/components/lbutton.vue';
import dayjs from 'dayjs';
const route = useRoute();

const { login, isLoggedIn, user, loading, logout, watchAuthState, unwatchAuthState } = useFirebaseAuth();

onMounted(() => {
    watchAuthState();
});

onUnmounted(() => {
    unwatchAuthState();
});

const logoutClick = () => {
    logout();
    navigateTo('/admin/login');
}

const links = [
    {
        name: 'Ansatte',
        path: '/admin/ansatte'
    },
    {
        name: 'Åpningstider',
        path: '/admin/openinghours'
    },
    {
        name: 'Kontakt',
        path: '/admin/kontakt'
    },
    {
        name: 'Priser',
        path: '/admin/priser'
    },
    {
        name: 'Nyheter',
        path: '/admin/nyheter'
    },
    {
        name: 'Lenker',
        path: '/admin/links'
    }
]


</script>
<template>
    <div class="flex flex-col min-h-screen">        
        <div class="@container bg-slate-600 text-white py-4">
            <div class="flex flex-row justify-around">
                <div class="flex flex-row gap-4">
                    <NuxtLink v-for="link in links" :key="link.name" v-if="isLoggedIn" :to="link.path" :class="{ 'underline': route.path === link.path }">
                        {{ link.name }}</NuxtLink>
                </div>
                <div class="flex flex-row gap-4">
                    <span v-if="isLoggedIn">Logget inn som: {{ user?.email }}</span>
                    <LButton text="Logg inn" v-if="!isLoggedIn" @click="navigateTo('/admin/login')" />
                    <LButton text="Logg ut" v-if="isLoggedIn" @click="logoutClick" size="sm" />
                </div>
            </div>
        </div>

        <div class="p-4 flex-grow">
            <slot />
        </div>
    </div>


</template>